const resources = {
  "en": {
    "login": {
      "heroTitle": "Clarity starts with a confident login",
      "heroDescription": "Your personal finance workspace awaits: bring accounts, debts, and goals together to track cash flow, organize plans, and monitor progress.",
      "heroStatsGrowth": "track free‑cash trends over time",
      "heroStatsForecast": "forecast scenarios to support planning",
      "signInTitle": "Sign in",
      "signInSubtitle": "Enter your credentials to continue building your financial plan.",
      "languagePrompt": "🌐 Interface language",
      "emailLabel": "Email",
      "passwordLabel": "Password",
      "enterEmail": "Enter your email",
      "enterPassword": "Enter your password",
      "loginButton": "Sign in",
      "registerLink": "Create account",
      "forgotPasswordLink": "Forgot password?",
      "secondaryActionsLabel": "Secondary sign-in options",
      "errorGenericTitle": "Unable to sign in",
      "errorGenericDescription": "Please double-check your email and password, then try again.",
      "unverifiedTitle": "Confirm your email to continue",
      "unverifiedDescription": "Your account is almost ready. Please verify your email address so we can keep your data secure.",
      "resendVerificationCta": "Resend verification email",
      "resendVerificationSent": "Verification email sent. Please check your inbox.",
      "resendVerificationError": "Unable to resend verification email. Please try again later.",
      "resendVerificationEmailRequired": "Enter your email above so we can resend the verification link.",
      "successToast": "Signed in successfully.",
      "twoFactor": {
        "cardTitle": "Two-factor verification",
        "title": "Verify your identity",
        "subtitle": "Choose a verification method for {{email}}.",
        "passwordAccepted": "Password accepted. Select a second factor to finish signing in.",
        "sessionExpires": "Session expires {{date}}",
        "methodLabel": "Select a verification method",
        "methods": {
          "email": "Email code",
          "webauthn": "Security key"
        },
        "errorTitle": "Verification failed",
        "errorGeneric": "Unable to verify the code. Please try again.",
        "otpSent": "Verification code sent to your email.",
        "otpError": "Unable to send the verification code. Please try again.",
        "codeLabel": "Enter your {{method}} code",
        "codeRequired": "Enter the verification code to continue.",
        "codePlaceholder": "Your 6-digit code",
        "requestCode": "Send code",
        "resendIn": "Resend in {{seconds}}s",
        "codeExpires": "Code expires at {{date}}",
        "attemptsRemaining": "{{count}} attempts remaining",
        "verifyCode": "Verify and continue",
        "webauthnDescription": "Use a registered security key or built-in authenticator.",
        "useSecurityKey": "Use security key",
        "registerSecurityKey": "Register new security key",
        "webauthnRegisterAnother": "Add another security key",
        "webauthnUseExistingToggle": "Use an existing key instead",
        "webauthnAuthenticateModeDescription": "Use one of your saved passkeys to finish signing in.",
        "webauthnRegisterModeDescription": "Register a new passkey to sign in from an additional device.",
        "webauthnUnavailable": "Security keys are not supported on this device.",
        "webauthnCanceled": "Security key verification was cancelled. Try again when you are ready.",
        "methodUnavailable": "This verification method is not available right now.",
        "backToPassword": "Back to password step"
      }
    }
  },
  "uk": {
    "login": {
      "heroTitle": "Чіткість починається з упевненого входу",
      "heroDescription": "Ваш персональний фінансовий простір уже чекає: об’єднайте рахунки, борги та цілі, щоб відстежувати грошові потоки, упорядковувати плани й контролювати прогрес.",
      "heroStatsGrowth": "відстежуйте динаміку вільних коштів з часом",
      "heroStatsForecast": "сценарії прогнозу для підтримки планування",
      "signInTitle": "Вхід",
      "signInSubtitle": "Введіть свої дані, щоб продовжити створення фінансового плану.",
      "languagePrompt": "🌐 Мова інтерфейсу",
      "emailLabel": "Електронна пошта",
      "passwordLabel": "Пароль",
      "enterEmail": "Введіть електронну пошту",
      "enterPassword": "Введіть пароль",
      "loginButton": "Увійти",
      "registerLink": "Створити акаунт",
      "forgotPasswordLink": "Забули пароль?",
      "secondaryActionsLabel": "Додаткові варіанти входу",
      "errorGenericTitle": "Не вдалося увійти",
      "errorGenericDescription": "Перевірте електронну пошту та пароль і спробуйте ще раз.",
      "unverifiedTitle": "Підтвердьте пошту, щоб продовжити",
      "unverifiedDescription": "Ваш акаунт майже готовий. Підтвердьте електронну адресу, щоб ми могли захистити ваші дані.",
      "resendVerificationCta": "Надіслати лист підтвердження ще раз",
      "resendVerificationSent": "Лист підтвердження надіслано. Перевірте вхідні.",
      "resendVerificationError": "Не вдалося надіслати лист підтвердження. Спробуйте пізніше.",
      "resendVerificationEmailRequired": "Введіть електронну пошту вище, щоб повторно надіслати посилання.",
      "successToast": "Вхід успішний.",
      "twoFactor": {
        "cardTitle": "Двофакторна перевірка",
        "title": "Підтвердьте свою особу",
        "subtitle": "Оберіть спосіб перевірки для {{email}}.",
        "passwordAccepted": "Пароль прийнято. Оберіть другий фактор, щоб завершити вхід.",
        "sessionExpires": "Сеанс завершується {{date}}",
        "methodLabel": "Оберіть спосіб перевірки",
        "methods": {
          "email": "Код з електронної пошти",
          "webauthn": "Ключ безпеки"
        },
        "errorTitle": "Перевірка не вдалася",
        "errorGeneric": "Не вдалося перевірити код. Спробуйте ще раз.",
        "otpSent": "Код перевірки надіслано на вашу пошту.",
        "otpError": "Не вдалося надіслати код перевірки. Спробуйте ще раз.",
        "codeLabel": "Введіть код {{method}}",
        "codeRequired": "Введіть код перевірки, щоб продовжити.",
        "codePlaceholder": "Ваш 6-значний код",
        "requestCode": "Надіслати код",
        "resendIn": "Повторне надсилання через {{seconds}}с",
        "codeExpires": "Термін дії коду до {{date}}",
        "attemptsRemaining": "Залишилося спроб: {{count}}",
        "verifyCode": "Підтвердити та продовжити",
        "webauthnDescription": "Скористайтеся зареєстрованим ключем безпеки або вбудованим автентифікатором.",
        "useSecurityKey": "Використати ключ безпеки",
        "registerSecurityKey": "Зареєструвати новий ключ безпеки",
        "webauthnRegisterAnother": "Додати ще один ключ безпеки",
        "webauthnUseExistingToggle": "Натомість використати наявний ключ",
        "webauthnAuthenticateModeDescription": "Скористайтеся одним зі збережених паскіїв, щоб завершити вхід.",
        "webauthnRegisterModeDescription": "Зареєструйте новий паскій, щоб входити з додаткового пристрою.",
        "webauthnUnavailable": "Ключі безпеки не підтримуються на цьому пристрої.",
        "webauthnCanceled": "Перевірку ключем безпеки скасовано. Спробуйте ще раз, коли будете готові.",
        "methodUnavailable": "Цей спосіб перевірки зараз недоступний.",
        "backToPassword": "Повернутися до пароля"
      }
    }
  }
};

export default resources;
